import { createSvgComponent } from "../../icon/createSvgComponent";
import Bookmark from "@core/__generated__/icon/figma/bookmark.svg";
export default createSvgComponent(Bookmark);